export const CURRENT_USER_LOADED = "user/usersLoaded"

export const CURRENT_USER_LOG_OUT = "user/logout"